import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import { useState } from 'react';
import BlogGrid from '../../components/NewLandingPage/blog';
import InterviewsBlogs from './InterviewsBlogs';
import StoriesSection from './StoriesSection';
import { useEffect } from 'react';

function Blogs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const filterOptions = ['All', 'Carbon Credits', 'Projects', 'Programs', 'Emissions'];

  return (
    <div className="overflow-x-hidden w-full">
      <Header />
      <section className='mt-24 md:mt-32 lg:mt-40 px-4 md:px-6 lg:px-8 xl:px-16 w-full max-w-full lg:max-w-[1400px] mx-auto lg:mx-0 lg:ml-64 overflow-hidden'>
        <div className="text-[28px] md:text-[40px] lg:text-[48px] font-bold">
          <span className="text-[#0D924F]"> CloseCarbon </span>Blogs, Interviews and Stories
        </div>
        <div className="text-[14px] md:text-[15px] lg:text-[16px] text-[#3B3B3B] mt-2">
          Subscribe to stay updated on latest carbon reduction initiatives, sustainable solutions, and environmental innovations.
        </div>
      </section>

      <div className="px-4 md:px-6 lg:px-8 xl:px-16 w-full max-w-full lg:max-w-[1400px] mx-auto lg:mx-0 lg:ml-64 mb-20 md:mb-32 lg:mb-40 mt-10 md:mt-32 lg:mt-40 text-[16px] overflow-hidden">
        {/* Left Section - Filters and Search */}
        <div className="flex flex-col lg:flex-row items-stretch lg:items-center w-full gap-2">

          {/* Filter Dropdown Button */}
          <div className="relative w-full lg:w-auto flex-shrink-0">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex flex-row justify-center items-center px-6 h-[56px] w-full lg:w-auto bg-[#F6F6F6] rounded-lg hover:bg-gray-100 transition-colors"
            >
              <span className="font-normal text-[14px] lg:text-[16px] leading-[19px] text-[#006633] whitespace-nowrap">
                {selectedFilter}
              </span>
              <div className="w-4 h-4 ml-2 relative flex-shrink-0">
                <svg
                  className="w-4 h-4"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 6L8 10L12 6"
                    stroke="#898989"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </button>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="absolute top-full left-0 mt-1 w-full lg:w-[160px] bg-white rounded-lg shadow-lg border border-gray-200 z-10">
                {filterOptions.map((option) => (
                  <button
                    key={option}
                    onClick={() => {
                      setSelectedFilter(option);
                      setIsDropdownOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-sm text-[#141414] hover:bg-[#FAFAFA] hover:text-[#006633] transition-colors first:rounded-t-lg last:rounded-b-lg"
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Search Bar */}
          <div className="flex flex-row items-center py-[18px] px-4 lg:px-3 gap-3 lg:gap-10 w-full min-w-0 h-[56px] bg-[#F6F6F6] rounded-2xl">
            <div className="flex flex-row items-center gap-2 lg:gap-4 w-full min-w-0">
              {/* Search Icon */}
              <div className="w-5 h-5 relative flex-shrink-0">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke="#B1B1B1" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              {/* Search Input */}
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search blog here..."
                className="w-full min-w-0 font-normal text-[14px] lg:text-[16px] leading-[19px] text-[#B1B1B1] bg-[#F6F6F6] outline-none focus:text-[#141414]"
              />
            </div>
          </div>
        </div>

      </div>
      <div className='px-4 md:px-6 lg:px-8 xl:px-16 w-full max-w-full lg:max-w-[1400px] mx-auto lg:mx-0 lg:ml-64 mb-10 md:mb-16 lg:mb-20 text-[24px] md:text-[32px] lg:text-[36px] font-bold overflow-hidden'>Blog</div>
      <BlogGrid />
      <InterviewsBlogs />
      <StoriesSection />
      <Footer />
    </div>
  )
}

export default Blogs